import { formatDate } from '@angular/common';

/**
 * Built-in patient tags the backend works out from satisfaction surveys (utils/surveyTags.js). They are
 * offered in the Patient Tags filter only, never as tags to add to a patient.
 */
export const SURVEY_TAGS = [
  'Satisfaction survey completed',
  'Low survey score (2 or less)',
  'Survey sent, not completed',
];
const NOT_COMPLETED = SURVEY_TAGS[2];

export const isSurveyTag = (tag: string): boolean => SURVEY_TAGS.includes(tag);

/** The filter's tag list: the built-in survey tags first, then the practice's own tags. */
export const withSurveyTags = (groupTags: string[] | null | undefined): string[] =>
  [...SURVEY_TAGS, ...(groupTags || []).filter((tag) => !isSurveyTag(tag))];

/** The line under a patient listed by a survey tag, e.g. "Survey completed: 13/10/2026 · Score 4.5". */
export const surveyLine = (survey: { tag: string; date: any; score: number | null } | null | undefined): string => {
  if (!survey) return '';
  const date = formatDate(survey.date, 'dd/MM/yyyy', 'en-US');
  if (survey.tag === NOT_COMPLETED) return `Survey sent: ${date}`;
  return `Survey completed: ${date}` + (survey.score ? ` · Score ${survey.score}` : '');
};
